<div [ngClass]="{'hidden': (loading$|async) === true}">
  <div class="header">
    <img class="logo"
      src="./assets/allianz_transperant_logo.png"
      alt="">

      <div class="header-img">
        <h1>
          Allianz My Life
          <br> Сигурност в несигурни дни
          </h1>
        </div>

        <div class="header-button-container">
          <button type="button"
            class="header-button"
            (click)="expandTheHeader()">
            <span class="header-button-text"> Защо да избереш Allianz My Life </span>
            @if (!isHeaderButtonClicked) {
              <span>
                <nx-icon name="chevron-right" class="white" size="s" aria-hidden="true"></nx-icon>
              </span>
            }
            @if (isHeaderButtonClicked) {
              <span>
                <nx-icon name="chevron-down" class="white" size="s" aria-hidden="true"></nx-icon>
              </span>
            }
          </button>
        </div>

        <!-- Expanded part after the button is clicked -->
        @if (isHeaderButtonClicked) {
          <div
            class="header-button-container-extended-part">
            <div class="financial-protection-container"
              (click)="expandFinancialProtection()">
              <img class="financial-protection-logo"
                src="./assets/present_small.png"
                alt="">
                @if (!isFinancialProtectionClicked) {
                  <div>ФИНАНСОВА СИГУРНОСТ</div>
                }
                @if (isFinancialProtectionClicked) {
                  <div>Получавате част от застрахователната премия при изтичане срока на полицата и редовно плащане</div>
                }
              </div>
              <div class="protection-container"
                (click)="expandProtection()">
                <img class="protection-logo"
                  src="./assets/shield_small.png"
                  alt="">
                  @if (!isProtectionClicked) {
                    <div>ЗАЩИТА</div>
                  }
                  @if (isProtectionClicked) {
                    <div>Финансова защита при непредвидени ситуации</div>
                  }
                </div>
                <div class="choice-container"
                  (click)="expandChoice()">
                  <img class="choice-logo"
                    src="./assets/save_small.png"
                    alt="">
                    @if (!isChoiceClicked) {
                      <div>ИЗБОР</div>
                    }
                    @if (isChoiceClicked) {
                      <div>Вие сами може да изберете покритите рискове</div>
                    }
                  </div>
                  <div class="second-medical-opinion-container"
                    (click)="expandSecondMedicalOption()">
                    <img class="second-medical-opinion-logo"
                      src="./assets/health-bag-doctor_small.png"
                      alt="">
                      @if (!isSecondMedicalOptionClicked) {
                        <div>ВТОРО ЛЕКАРСКО МНЕНИЕ</div>
                      }
                      @if (isSecondMedicalOptionClicked) {
                        <div>Получавате вторo лекарско мнение от MediGuide International</div>
                      }
                    </div>
                    <!-- <div class="all-over-the-world-cover-container" (click)="expandAllOverTheWorldCover()">
                    <img class="all-over-the-world-cover-logo" src="./assets/sharing-connect_small.png" alt="">
                    <div *ngIf="!isAllOverTheWorldCoverClicked">ПОКРИТИЕ: ЦЯЛ СВЯТ</div>
                    <div *ngIf="isAllOverTheWorldCoverClicked">Териториално покритие на застраховката – ЦЯЛ СВЯТ</div>
                  </div> -->
                </div>
              }
              <!-- Expanded part after the button is clicked -->

            </div>

            <!-- Rest of the screen -->
            @if ((currencyService.currencyConfig$|async)!== '') {
              <div class="max-width-1200">
                <!-- Call main input form component, which contains text with the gaps -->
                <app-main-input-form (changeData)="onChangedData($event)"
                  (isEverythingCorrect)="showPackages($event)"
                  (hidePackages)="hidePackages($event)"
                (initManPrem)="initManPremHandler($event)"></app-main-input-form>
                <!-- Container of the packages and the text-->
                @if (doShowPackages) {
                  <div class="packages-form clearfix"
                    >
                    <div class="choose-package-text">ИЗБЕРЕТЕ ОТ СЛЕДНИТЕ ПАКЕТИ, ЗА ДА ИЗЧИСЛИТЕ СВОЯТА ВНОСКА</div>
                    <!-- Container of the packages -->
                    @if (!hide) {
                      <div class="packages-container"
                        >
                        <div class="app-protect-light div-col-2">
                          <div class="app-protect-light">
                            <!-- Call protect light component -->
                            <app-protect-light [dataJSON]="handledDataJSON"
                              (sendJSONWithPrem)="onChangedPrem($event)"
                              [hideIllnessWhenOver65Years]="hide"
                              (isCrillAndSecMedOPChecked)="lightCheck($event)"
                              [plusCheck]="isCrillAndSecMedOPChecked2"
                            [protectCheck]="isCrillAndSecMedOPChecked3"></app-protect-light>
                          </div>
                          <div class="app-protect-plus">
                            <!-- Call protect plus component -->
                            <app-protect-plus [dataJSON]="handledDataJSON"
                              (sendJSONWithPrem)="onChangedPrem($event)"
                              [hideIllnessWhenOver65Years]="hide"
                              (isCrillAndSecMedOPChecked)="plusCheck($event)"
                              [lightCheck]="isCrillAndSecMedOPChecked1"
                            [protectCheck]="isCrillAndSecMedOPChecked3"></app-protect-plus>
                          </div>
                        </div>
                        <div class="app-protect-premium div-col-2 clearfix">
                          <div class="app-protect-premium">
                            <!-- Call protect premium component -->
                            <app-protect-premium [dataJSON]="handledDataJSON"
                              (sendJSONWithPrem)="onChangedPrem($event)"
                              (isCrillAndSecMedOPChecked)="protectCheck($event)"
                              [lightCheck]="isCrillAndSecMedOPChecked1"
                            [plusCheck]="isCrillAndSecMedOPChecked2"></app-protect-premium>
                          </div>
                          <div class="app-protect-custom">
                            <!-- Call protect custom component -->
                            <app-protect-custom [dataJSON]="handledDataJSON"
                              (sendJSONWithPrem)="onChangedPrem($event)"
                              (exportReturnedData)="getProtectCustomData($event)"
                            [hideIllnessWhenOver65Years]="hide"></app-protect-custom>
                          </div>
                        </div>
                      </div>
                    }
                    @if (hide) {
                      <div class="packages-container"
                        >
                        <div class="app-protect-light div-col-2">
                          <div class="app-protect-light">
                            <!-- Call protect light component -->
                            <app-protect-light [dataJSON]="handledDataJSON"
                              (sendJSONWithPrem)="onChangedPrem($event)"
                              [hideIllnessWhenOver65Years]="hide"
                              (isCrillAndSecMedOPChecked)="lightCheck($event)"
                              [plusCheck]="isCrillAndSecMedOPChecked2"
                            [protectCheck]="isCrillAndSecMedOPChecked3"></app-protect-light>
                          </div>
                        </div>
                        <div class="app-protect-premium div-col-2 clearfix">
                          <div class="app-protect-plus">
                            <!-- Call protect plus component -->
                            <app-protect-plus [dataJSON]="handledDataJSON"
                              (sendJSONWithPrem)="onChangedPrem($event)"
                              [hideIllnessWhenOver65Years]="hide"
                              (isCrillAndSecMedOPChecked)="plusCheck($event)"
                              [lightCheck]="isCrillAndSecMedOPChecked1"
                            [protectCheck]="isCrillAndSecMedOPChecked3"></app-protect-plus>
                          </div>
                        </div>
                        <div class="app-protect-custom div-col-2 custom-package-align-whenover65">
                          <div class="app-protect-custom">
                            <app-protect-custom [dataJSON]="handledDataJSON"
                              (sendJSONWithPrem)="onChangedPrem($event)"
                              (exportReturnedData)="getProtectCustomData($event)"
                            [hideIllnessWhenOver65Years]="hide"></app-protect-custom>
                          </div>
                        </div>
                      </div>
                    }
                    <!-- End of the container of the packages -->
                  </div>
                }
                <!-- End of the container of the packages and the text -->
                <!-- Container of the sum, which comes back from allianz -->
                @if (manPrem && doShowPackages) {
                  <div
                    id="result">
                    <app-payment-form [getJSONWithPrem]="handledJSONWithPrem"
                      [getCurrency]="currency"
                      [getAmoutOfMoney]="amoutOfMoney"
                      [getYears]="handledDataJSON.years"
                      [getSelectedPaymentType]="selectedPaymentType"
                      [getInitManPrem]="initManPrem"
                      (calculateAgain)="exportFromPayment($event)"
                    (changePackage)="removePackage($event)"></app-payment-form>
                  </div>
                }
                <!-- End of the container of the sum, which comes back from allianz -->
                <!-- Next step section, where the user could send an email to itself -->
                @if (manPrem && doShowPackages) {
                  <div
                    class="next-step-section max-width-1200">
                    <div class="next-step-section-title">
                      <b>Какво да правите сега?</b>
                    </div>
                    <div class="next-step-section-forms">
                      <div class="email"
                        (click)="showDialog = !showDialog; isEmailChosen = true; isPrintChosen = false;">
                        <img class="email-logo"
                          src="./assets/at-sign.png"
                          alt="">
                          <div>Изпратете това предложение на Вашия имейл за бърза справка в бъдеще.</div>
                        </div>
                        <div class="print-paper hide-on-mobile"
                          (click)="showDialog = !showDialog; isPrintChosen = true; isEmailChosen = false;">
                          <img class="email-logo"
                            src="./assets/paper-document.png"
                            alt="">
                            <div>Принтирайте Вашето индивидуално предложение.</div>
                          </div>
                          <a href="https://www.allianz.bg/offices/"
                            class="contact-with-us-a"
                            target="_blank">
                            <div class="contact-with-us">
                              <img class="contact-with-us-logo"
                                src="./assets/person.png"
                                alt="">
                                <div>Уговорете си среща с наш представител, за да получите професионален съвет.</div>
                              </div>
                            </a>
                            <a href="https://www.allianz.bg/bg_BG/individuals/get-in-touch.html"
                              class="contact-data-a"
                              target="_blank">
                              <div class="contact-data">
                                <img class="contact-data-logo"
                                  src="./assets/clock.png"
                                  alt="">
                                  <div>Нямате време? Оставете данни за контакт и ние ще се свържем с Вас.</div>
                                </div>
                              </a>
                            </div>
                          </div>
                        }
                        <!--End of the next step section, where the user could send an email to itself -->
                      </div>
                    }
                    <!-- End of the rest of the screen -->

                    <!-- Modal Form -->

                    <app-custom-modal-form [(visible)]="showDialog">

                      <!-- User input Section -->
                      <form [formGroup]="userFormGroup"
                        class="form-group">
                        <div class="name-input-div">
                          <label>Име</label>
        <input [ngClass]="
        {
          'red-shadow': (userFormGroup.controls['username'].dirty ||
                      userFormGroup.controls['username'].touched) &&
                      (userFormGroup.controls['username'].errors?.pattern ||
                      userFormGroup.controls['username'].errors?.required),
          'green-shadow': (userFormGroup.controls['username'].dirty ||
                        userFormGroup.controls['username'].touched) &&
                        !(userFormGroup.controls['username'].errors?.pattern ||
                        userFormGroup.controls['username'].errors?.required)
        }"
                            formControlName="username">

                            @if (
                              (userFormGroup.controls['username'].dirty ||
                              userFormGroup.controls['username'].touched) &&
                              (userFormGroup.controls['username'].errors?.pattern ||
                              userFormGroup.controls['username'].errors?.required)) {
                              <div class="error-text-container"
                                >
                                @if (
                                  userFormGroup.controls['username'].errors?.pattern ||
                                  userFormGroup.controls['username'].errors?.required) {
                                  <div class="arrow-up"
                                  ></div>
                                }
                                @if (userFormGroup.controls['username'].errors?.pattern) {
                                  <div class="error-message"
                                    >
                                    <small>Позволени символи: букви,интервал,тире,точка,апостроф.</small>
                                  </div>
                                }
                                @if (userFormGroup.controls['username'].errors?.required) {
                                  <div class="error-message"
                                    >
                                    <small>Задължително поле</small>
                                  </div>
                                }
                              </div>
                            }
                          </div>

                          @if (isEmailChosen) {
                            <div
                              class="email-input-div">
                              <label>Електронен адрес</label>
        <input [ngClass]="
        {
          'red-shadow': (userFormGroup.controls['email'].dirty ||
                      userFormGroup.controls['email'].touched) &&
                      (userFormGroup.controls['email'].errors?.pattern ||
                      userFormGroup.controls['email'].errors?.required),
          'green-shadow': (userFormGroup.controls['email'].dirty ||
                        userFormGroup.controls['email'].touched) &&
                        !(userFormGroup.controls['email'].errors?.pattern ||
                        userFormGroup.controls['email'].errors?.required)
        }"
                                formControlName="email">
                                @if (
                                  (userFormGroup.controls['email'].dirty ||
                                  userFormGroup.controls['email'].touched) &&
                                  (userFormGroup.controls['email'].errors?.pattern ||
                                  userFormGroup.controls['email'].errors?.required)) {
                                  <div class="error-text-container"
                                    >
                                    @if (
                                      userFormGroup.controls['email'].errors?.pattern ||
                                      userFormGroup.controls['email'].errors?.required) {
                                      <div class="arrow-up"
                                      ></div>
                                    }
                                    @if (userFormGroup.controls['email'].errors?.pattern) {
                                      <div class="error-message"
                                        >
                                        <small>Невалиден формат на eлектронен адрес (email).</small>
                                      </div>
                                    }
                                    @if (userFormGroup.controls['email'].errors?.required) {
                                      <div class="error-message"
                                        >
                                        <small>Задължително поле</small>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }

                          </form>
                          <!-- User input Section-->

                          <div class="custom-modal-form-buttons">
                            @if (isEmailChosen) {
                              <button
                                (click)="sendOrPrint()"
                              class="send-print-btn">Изпрати</button>
                            }
                            @if (isPrintChosen) {
                              <button
                                (click)="sendOrPrint(false, true)"
                              class="send-print-btn">Принтирай</button>
                            }
                            <button (click)="showDialog = !showDialog"
                            class="close-btn">Затвори</button>
                          </div>

                          <div class="custom-modal-form-error-text">

                            @if (isSendButtonClicked && !isEmailSent && (!isThereEmptyField && areAllInputFieldsCorrect)) {
                              <small class="email-info-message"
                              >В момента подготвяме Вашето предложение.</small>
                            }
                            @if (isEmailSent) {
                              <small class="email-info-message"
                              >Изпратихме Вашето предложение на посочения имейл.</small>
                            }

                            @if (isEmailChosen && isThereEmptyField) {
                              <small>Всички полета са задължителни! <br> Моля, попълнете празните полета по-горе!</small>
                            }
                            @if (isEmailChosen && !areAllInputFieldsCorrect) {
                              <small>Данните са грешно попълнени! Моля, коригирайте ги!</small>
                            }

                            @if (isPrintChosen && isThereEmptyFieldPrint) {
                              <small>Моля, попълнете празното поле по-горе!</small>
                            }
                            @if (isPrintChosen && !areAllInputFieldsCorrectPrint) {
                              <small>Данните са грешно попълнени! Моля, коригирайте ги!</small>
                            }
                            @if (isPrintChosen && !isPDFGenerated) {
                              <small>Документът не беше генериран правилно. Моля, опитайте отново!</small>
                            }
                          </div>
                        </app-custom-modal-form>

                        <!-- Modal Form -->
                      </div>

                      <!-- Loader -->
                      @if (loading$|async) {
                        <div class="loading">
                          <nx-spinner size="large"></nx-spinner>
                        </div>
                      }
